import * as React from "react";
export var ModalLoader = function (_a) {
    var show = _a.show, height = _a.height, text = _a.text, _b = _a.className, className = _b === void 0 ? "" : _b;
    var styles = {
        display: show && show == true ? "flex" : "none",
    };
    var style2 = {
        height: height || "auto",
    };
    return (React.createElement("div", { className: className },
        React.createElement("div", { id: "myModal", className: "modal", style: styles },
            React.createElement("div", { className: "modal-content thankyou_modal_styling", style: style2 },
                React.createElement("div", { className: "modal_header_text" }, text || "PREPARING YOUR REPORT"),
                React.createElement("div", { className: "loaderAlignment" },
                    React.createElement("div", { className: "loader" }))))));
};
export var ModalThankyou = function (_a) {
    var show = _a.show, height = _a.height, text = _a.text, email = _a.email, closeBtn = _a.closeBtn, onClick = _a.onClick, _b = _a.className, className = _b === void 0 ? "" : _b;
    var styles = {
        display: show && show == true ? "flex" : "none",
    };
    var style2 = {
        height: height || "auto",
    };
    return (React.createElement("div", { className: className },
        React.createElement("div", { id: "myModal", className: "modal", style: styles },
            React.createElement("div", { className: "modal-content thankyou_modal_styling", style: style2 },
                React.createElement("div", { className: "thankyou_modal_header_text" }, text || "Your report has been sent to"),
                React.createElement("div", { className: "thankyou_email_text" }, email || ""),
                React.createElement("div", { className: "thankyou_text" }, "Thank you!"),
                React.createElement("button", { className: "CloseBtn", onClick: onClick, style: { display: closeBtn == "hide" ? "none" : "" } }, "Close")))));
};
export var Custom_modal = function (_a) {
    var show = _a.show, _b = _a.width, width = _b === void 0 ? "100%" : _b, setOpen = _a.setOpen, _c = _a.className, className = _c === void 0 ? "" : _c, _d = _a.children, children = _d === void 0 ? "" : _d, _e = _a.id, id = _e === void 0 ? "custom_modal" : _e;
    var styling = {
        padding: "24px",
        borderRadius: "16px",
        boxShadow: "rgb(167 176 192 / 50%) 0px 0px 24px",
        minHeight: "30px",
        width: width,
        bottom: "0px",
    };
    document.addEventListener("mousedown", function (event) {
        var concernedElement = document.querySelector("#" + id);
        if (!concernedElement.contains(event.target)) {
            if (show)
                setOpen(false);
        }
    });
    return (React.createElement("div", { className: "custom_modal", id: id, style: { display: show ? "" : "none" } },
        React.createElement("div", { className: className + " custom_modal_div", style: styling }, children)));
};
